import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  font-size: ", ";\n  cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 1.5;\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 1.5;\n  font-weight: 600;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 32px;\n  height: 32px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  position: relative;\n  width: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  transform-origin: top center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import styled, { ThemeProvider } from 'styled-components';
import { position } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import posed, { PoseGroup } from 'react-pose';
import { theme } from '../themes/default';
import { Flex, Box } from '../grid/Grid';
import { Icon } from '../icon/Icon';
import iconSuccess from './success.svg';
import iconError from './error.svg';
import iconWarning from './warning.svg';
var PLACEMENT = {
  TOP_RIGHT: 'topRight',
  TOP_LEFT: 'topLeft',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM_LEFT: 'bottomLeft'
};
var placementStyleMap = {
  topRight: {
    top: 10,
    right: 10
  },
  topLeft: {
    top: 10,
    left: 10
  },
  bottomRight: {
    bottom: 10,
    right: 10
  },
  bottomLeft: {
    bottom: 10,
    left: 10
  }
};

var getContainer = function getContainer(key) {
  var id = "notification-".concat(key);
  var container = document.getElementById(id);

  if (container) {
    return container;
  } else {
    var div = document.createElement('div');
    div.id = id;
    document.body.appendChild(div);
    return div;
  }
};

var StyledNotification = styled.div(_templateObject(), themeGet('zIndex.tooltip'), position);
var Wrapper = styled(Box).attrs({
  display: 'flex',
  pl: 5,
  pr: 4,
  py: 4,
  mb: 5
})(_templateObject2(), themeGet('notification.width'), themeGet('notification.borderRadius'), themeGet('notification.boxShadow'), themeGet('notification.backgroundColor'));
var StatusIcon = styled.img(_templateObject3());
var Title = styled(Box)(_templateObject4(), themeGet('notification.title.fontSize'), themeGet('notification.title.color'));
var Desc = styled(Box)(_templateObject5(), themeGet('notification.description.fontSize'), themeGet('notification.description.color'));
var CloseButton = styled(Icon).attrs({
  name: 'close'
})(_templateObject6(), themeGet('notification.closeButton.top'), themeGet('notification.closeButton.right'), themeGet('notification.closeButton.fontSize'));

var NotificationCard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NotificationCard, _React$PureComponent);

  function NotificationCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NotificationCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NotificationCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "closeTimer", null);

    _defineProperty(_assertThisInitialized(_this), "close", function (e) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          cardKey = _this$props.cardKey;

      if (e) {
        e.stopPropagation();
      }

      _this.clearCloseTimer();

      onClose(cardKey);
    });

    _defineProperty(_assertThisInitialized(_this), "startCloseTimer", function () {
      var duration = _this.props.data.duration;

      if (duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, duration);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearCloseTimer", function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    });

    return _this;
  }

  _createClass(NotificationCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.restartCloseTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function restartCloseTimer() {
      this.clearCloseTimer();
      this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$data = this.props.data,
          message = _this$props$data.message,
          description = _this$props$data.description,
          icon = _this$props$data.icon;
      return (
        /*#__PURE__*/
        React.createElement(Wrapper, {
          ref: this.props.innerRef
        },
        /*#__PURE__*/
        React.createElement(StatusIcon, {
          src: icon
        }),
        /*#__PURE__*/
        React.createElement(Flex, {
          flexDirection: "column",
          justifyContent: "space-between"
        },
        /*#__PURE__*/
        React.createElement(Box, {
          ml: 5,
          mr: 4
        },
        /*#__PURE__*/
        React.createElement(Title, null, message),
        /*#__PURE__*/
        React.createElement(Desc, null, description))),
        /*#__PURE__*/
        React.createElement(CloseButton, {
          onClick: this.close
        }))
      );
    }
  }]);

  return NotificationCard;
}(React.PureComponent);

var NotificationCardWithRef =
/*#__PURE__*/
forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(NotificationCard, _extends({}, props, {
      ref: ref
    }))
  );
});
var NotificationCardWithAnimation = posed(NotificationCardWithRef)({
  init: {
    opacity: 0,
    x: '100%'
  },
  enter: {
    opacity: 1,
    x: '0%',
    transition: {
      duration: 300,
      ease: 'easeIn'
    }
  },
  exit: {
    opacity: 0,
    marginBottom: '-50%',
    transition: {
      duration: 300,
      ease: 'easeOut'
    }
  }
});

var NotificationList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NotificationList, _React$Component);

  function NotificationList() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, NotificationList);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(NotificationList)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      data: new Map()
    });

    _defineProperty(_assertThisInitialized(_this2), "add", function (config) {
      var key = config.key || Date.now();

      _this2.setState(function (state) {
        if (state.data.has(key)) {
          state.data.delete(key);
        }

        return state.data.set(key, config);
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "remove", function (key) {
      _this2.setState(function (state) {
        return state.data.delete(key);
      });
    });

    return _this2;
  }

  _createClass(NotificationList, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var data = this.state.data;
      var placement = this.props.placement;
      return (
        /*#__PURE__*/
        React.createElement(StyledNotification, placementStyleMap[placement],
        /*#__PURE__*/
        React.createElement(PoseGroup, {
          preEnterPose: "init"
        }, Array.from(data).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return (
            /*#__PURE__*/
            React.createElement(NotificationCardWithAnimation, {
              key: key,
              cardKey: key,
              data: value,
              onClose: _this3.remove
            })
          );
        })))
      );
    }
  }]);

  return NotificationList;
}(React.Component);

var cache = {};

NotificationList.getInstance = function (placement, callback) {
  if (cache[placement]) return callback(cache[placement]);
  var container = getContainer(placement);
  var called = false;
  ReactDOM.render(
  /*#__PURE__*/
  React.createElement(ThemeProvider, {
    theme: theme
  },
  /*#__PURE__*/
  React.createElement(NotificationList, {
    placement: placement,
    ref: function ref(notification) {
      if (called) return;
      called = true;
      var result = {
        notice: function notice(noticeProps) {
          notification.add(noticeProps);
        },
        removeNotice: function removeNotice(key) {
          notification.remove(key);
        },
        destory: function destory() {
          ReactDOM.unmountComponentAtNode(container);
        },
        component: notification
      };
      cache[placement] = result;
      callback(result);
    }
  })), container);
};

var notice = function notice(_ref3) {
  var key = _ref3.key,
      message = _ref3.message,
      description = _ref3.description,
      _ref3$placement = _ref3.placement,
      placement = _ref3$placement === void 0 ? PLACEMENT.TOP_RIGHT : _ref3$placement,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? 5000 : _ref3$duration,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? iconSuccess : _ref3$icon;
  NotificationList.getInstance(placement, function (notification) {
    notification.notice({
      key: key,
      message: message,
      description: description,
      duration: duration,
      icon: icon
    });
  });
};

export var Notification = {
  open: notice,
  success: function success(config) {
    return notice(_objectSpread({}, config, {
      icon: iconSuccess
    }));
  },
  error: function error(config) {
    return notice(_objectSpread({}, config, {
      icon: iconError
    }));
  },
  warning: function warning(config) {
    return notice(_objectSpread({}, config, {
      icon: iconWarning
    }));
  }
};